import { useTranslation } from 'react-i18next';
import {
  Archive,
  ArchiveRestore,
  Eye,
  Lock,
  LockOpen,
  Pencil,
} from 'lucide-react';

import type { TableActionsProps } from './types';

import { IconButton } from '@/components';

import { TableAction } from './TableAction';
import { TableDeleteAction } from './TableDeleteAction';

export const TableActions = (props: TableActionsProps) => {
  const { show, edit, lock, archive, remove, children } = props;
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1">
      {lock && (
        <IconButton
          label={lock.isLocked ? t('Unlock') : t('Lock')}
          variant={lock.isLocked ? 'destructive' : 'ghost'}
          onClick={lock.onClick}
        >
          {lock.isLocked ? (
            <Lock className="size-4" />
          ) : (
            <LockOpen className="size-4" />
          )}
        </IconButton>
      )}
      {show && (
        <TableAction
          target={show}
          label={t('View')}
          icon={<Eye className="size-4" />}
        />
      )}
      {edit && (
        <TableAction
          target={edit}
          label={t('Edit')}
          icon={<Pencil className="size-4" />}
        />
      )}
      {archive && (
        <IconButton
          label={archive.isArchived ? t('Restore') : t('Archive')}
          onClick={archive.onClick}
          disabled={archive.isPending}
        >
          {archive.isArchived ? (
            <ArchiveRestore className="size-4" />
          ) : (
            <Archive className="size-4" />
          )}
        </IconButton>
      )}
      {remove && <TableDeleteAction remove={remove} />}
      {children}
    </div>
  );
};
